//# sourceMappingURL=error.mjs.map
/// <reference types="./error.d.mts" />
import * as $ask from "../../altar/altar/ask.mjs";
import * as $fetch from "../../gleam_fetch/gleam/fetch.mjs";
import * as $response from "../../gleam_http/gleam/http/response.mjs";
import * as $decode from "../../gleam_stdlib/gleam/dynamic/decode.mjs";
import { Ok, Error, CustomType as $CustomType } from "../gleam.mjs";

export class FetchError extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const Error$FetchError = ($0) => new FetchError($0);
export const Error$isFetchError = (value) => value instanceof FetchError;
export const Error$FetchError$0 = (value) => value[0];

export class HttpError extends $CustomType {
  constructor(code, reason) {
    super();
    this.code = code;
    this.reason = reason;
  }
}
export const Error$HttpError = (code, reason) => new HttpError(code, reason);
export const Error$isHttpError = (value) => value instanceof HttpError;
export const Error$HttpError$code = (value) => value.code;
export const Error$HttpError$0 = (value) => value.code;
export const Error$HttpError$reason = (value) => value.reason;
export const Error$HttpError$1 = (value) => value.reason;

export class DecodeError extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const Error$DecodeError = ($0) => new DecodeError($0);
export const Error$isDecodeError = (value) => value instanceof DecodeError;
export const Error$DecodeError$0 = (value) => value[0];

export class NilError extends $CustomType {
  constructor(message) {
    super();
    this.message = message;
  }
}
export const Error$NilError = (message) => new NilError(message);
export const Error$isNilError = (value) => value instanceof NilError;
export const Error$NilError$message = (value) => value.message;
export const Error$NilError$0 = (value) => value.message;

export class AskError extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const Error$AskError = ($0) => new AskError($0);
export const Error$isAskError = (value) => value instanceof AskError;
export const Error$AskError$0 = (value) => value[0];

export function internal_error(response, reason) {
  let $ = response.status;
  if ($ === 500) {
    return new Error(new HttpError(500, reason));
  } else {
    return new Ok(response);
  }
}
